import { Box, Grid } from "@mui/material";
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../../../framework/appUtils";
import * as documentService from "../../../../../models/services/documentService";
import { CkEditorDialog } from "../../../../framework/Dialog/Dialog";
import { DialogItemsNav } from "../../../../framework/Dialog/DialogItemsNav";
import { FormField } from "../../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../../../framework/Grid/GridRow";
import { ModifyUserInfo } from "../../../../framework/User/ModifyUserInfo";
import { DialogButtons } from "source/components/framework/Dialog/DialogButtons";
import { Base } from "ui/Scripts/source/framework/base";
import { IDocumentVersionEditItem } from "source/models/documentVersion/documentVersionEditItem";
import { DocumentVersionType } from "ui/Scripts/source/models/enums";
import { AppCkEditor } from "source/components/framework/AppCkEditor";
import { VerticalContainer } from "ui/Scripts/source/components/framework/VerticalContainer";

export interface IDocumentVersionDialogProp {
    companyId: string;
    folderId: string;
    id: string;

    hasPrevious: boolean;
    hasNext: boolean;
    onPrevious: () => void;
    onNext: () => void;
    onCancel: () => void;
}

export interface IDocumentVersionDialogState {
    item: IDocumentVersionEditItem;
    ckEditorDataId: number;
}

export class DocumentVersionDialog extends React.Component<IDocumentVersionDialogProp, IDocumentVersionDialogState> {
    private editor: any = null;

    constructor(props: IDocumentVersionDialogProp) {
        super(props);
        this.state = {
            item: null,
            ckEditorDataId: 0
        };
    }

    setCkEditorContent = (value: string) => {
        this.setState({ ckEditorDataId: this.state.ckEditorDataId + 1 });
        if (!this.editor) return;
        this.editor.setData(value, {
            callback: () => {
                this.editor.resetDirty();
            }
        });
        this.setState({ ckEditorDataId: this.state.ckEditorDataId + 1 });
    };

    destroyCkEditor = () => {
        if (!this.editor) return;
        this.editor.destroy();
        this.editor = null;
    };

    handleCkEditorInstanceReady = (ev) => {
        this.editor = ev.editor;
        ev.editor.resetDirty();
        this.setCkEditorContent(this.state.item?.content ?? "");
    };
    // #endregion CkEditor

    loadData = async () => {
        const props = this.props;
        const result = await AppUtils.callService(() => documentService.getDocumentVersionEdit(props.companyId, props.folderId, props.id), false);
        if (!result) return;
        const item = result.item;
        const state = {
            item
        };
        this.setState(state, () => {
            this.setCkEditorContent(item.content);
        });
    };

    componentDidMount(): void {
        this.loadData();
    }
    
    componentWillUnmount(): void {
        this.destroyCkEditor();
    }

    async componentDidUpdate(prevProps: IDocumentVersionDialogProp, prevState: IDocumentVersionDialogState): Promise<void> {
        const props = this.props;
        if (prevProps.companyId === props.companyId && prevProps.id === props.id) return;
        this.loadData();
    }

    handlePrevious = async () => {
        this.props.onPrevious();
    };

    handleNext = async () => {
        this.props.onNext();
    };

    render() {
        const props = this.props;
        const state = this.state;
        if (!state.item) return null;
        return (
            <CkEditorDialog
                id="documentVersionDialog"
                maxWidth="lg"
                maxHeight="90%"
                title={Translations.Version + ": " + Base.timeToDateTimeStr(state.item.modifyUser.date)}
                body={
                    <Box height="calc(100% + 16px)">
                        <VerticalContainer
                            before={<>
                                <GridRow>
                                    <Grid item sm={2}>
                                        <FormField title={Translations.Time} fullWidth required margin="0">
                                            {Base.timeToDateTimeStr(state.item.modifyUser.date)}
                                        </FormField>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <FormField title={Translations.PublishVersion} fullWidth margin="0">
                                            {state.item.version.toString(10)}
                                        </FormField>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <FormField title={Translations.ContentVersion} fullWidth margin="0">
                                            {state.item.contentVersion.toString(10)}
                                        </FormField>
                                    </Grid>
                                    <Grid item sm={2}>
                                        <FormField title={Translations.Published} fullWidth margin="0">
                                            {state.item.type === DocumentVersionType.Publish ? Translations.Yes : Translations.No}
                                        </FormField>
                                    </Grid>
                                    <Grid item sm={4}>
                                        <FormField title={Translations.Saved} fullWidth margin="0">
                                            <ModifyUserInfo
                                                modifyUser={state.item.modifyUser}
                                            />
                                        </FormField>
                                    </Grid>
                                </GridRow>
                                <GridRow>
                                    <Grid item sm={12}>
                                        <FormField title={Translations.Contents} fullWidth>
                                        </FormField>
                                    </Grid>
                                </GridRow>
                            </>}
                            main={
                                <AppCkEditor
                                    fitToContainerHeight
                                    readOnly={true}
                                    value={state.item?.content}
                                    dataId={state.ckEditorDataId}
                                    height=""
                                    onInstanceReady={this.handleCkEditorInstanceReady}
                                    onChange={null}
                                />
                            }
                        />
                    </Box>
                }
                actions={
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <DialogItemsNav
                            hasPrevious={props.hasPrevious}
                            hasNext={props.hasNext}
                            onPrevious={this.handlePrevious}
                            onNext={this.handleNext}
                        />
                        <DialogButtons
                            cancelTitle={Translations.Close}
                            onCancel={props.onCancel}
                        />
                    </Box>
                }
                onClose={props.onCancel}
            />
        );
    }
}